export const actions = {
  DISTRIBUIDORES_LOAD_REQUESTED: 'DIAS_ESPECIALES_LOAD_REQUESTED',
  DISTRIBUIDORES_LOAD_SUCCEEDED: 'DIAS_ESPECIALES_LOAD_SUCCEEDED',
  DISTRIBUIDORES_LOAD_FILED: 'DIAS_ESPECIALES_LOAD_FILED',
}

export const getDistribuidoresAction = dispatch => {
  dispatch({
    type: actions.DISTRIBUIDORES_LOAD_REQUESTED,
  })
}
